/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'ngf-button-group',
  standalone: true
})
export class NgfButtonGroupDirective {

  @HostBinding('class.ngf-button--group')
  readonly ngfButtonGroup = true;

  @HostBinding('attr.vertical')
  @Input()
  vertical: boolean | null = null;

}
